<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="headline font-weight-bold ">Staff Attendance</v-subheader>
        </div>
      </v-col>
      <v-col cols="12" md='4' v-if="modules.AttendanceHome">
        <router-link :to="{ name: 'teacherAttendance' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Attendance Home"> </clickable-card>
        </router-link>
      </v-col>
      <v-col cols="12" md='4' v-if="modules.ApplyAttendance">
        <router-link :to="{ name: 'applyAttendance' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Apply Attendance"> </clickable-card>
        </router-link>
      </v-col>
      <v-col cols="12" md='4' v-if="modules.ApplyLeave">
        <router-link :to="{ name: 'applyLeave' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Apply Leave"> </clickable-card>
        </router-link>
      </v-col>
      <v-col cols="12" md='4' v-if="modules.LeaveReport">
        <router-link :to="{ name: 'leaveReport' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Leave Report"> </clickable-card>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'

export default {
  name: 'staffAttendanceHome',
  components: { ClickableCard },
  data () {
    return {
      modules: {
        ApplyAttendance: this.checkModuleAccess('ApplyAttendance'),
        LeaveReport: this.checkModuleAccess('LeaveReport'),
        ApplyLeave: this.checkModuleAccess('ApplyLeave'),
        AttendanceHome: this.checkModuleAccess('AttendanceHome')
      }
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>
